import funcs_numbers from "./funcs.numbers";

//	E X P O R T   L I B

export default class funcs_datetime {

//#region 																							D A T E T I M E   G E T   D A T E

	public static datetime___get___date(
		___datetime_string: Date | string
	) : string {

		const ___datetime_obj: Date = new Date(___datetime_string);
		
		const ___d___day: string = ___datetime_obj.getDate().toString().padStart(2, '0');
		const ___d___month: string = (___datetime_obj.getMonth() + 1).toString().padStart(2, '0');
		const ___d___year: string = ___datetime_obj.getFullYear().toString();
		
		return ___d___day.toString() + '/' + ___d___month.toString() + '/' + ___d___year.toString();

	}

//#endregion

//#region 																							D A T E T I M E   G E T   T I M E

	public static datetime___get___time(
		___datetime_string: Date | string
	) : string {

		const ___datetime_obj: Date = new Date(___datetime_string);
		
		const ___d___hours: string = ___datetime_obj.getHours().toString().padStart(2, '0');
		const ___d___minutes: string = ___datetime_obj.getMinutes().toString().padStart(2, '0');
		
		return ___d___hours.toString() + ':' + ___d___minutes.toString();

	}

//#endregion

//#region 																							D A T E T I M E   F O R M A T

	public static datetime___format___input_datetime_local(
		___date: Date
	) : string {
	
		const ___date___year: string = ___date.getFullYear().toString()
		const ___date___month: string = funcs_numbers.pad___twoDigits(___date.getMonth() + 1);
		const ___date___day: string = funcs_numbers.pad___twoDigits(___date.getDate());
		const ___date___hours: string = funcs_numbers.pad___twoDigits(___date.getHours());
		const ___date___minutes: string = funcs_numbers.pad___twoDigits(___date.getMinutes());

		return ___date___year + '-' + ___date___month + '-' + ___date___day + 'T' + ___date___hours + ':' + ___date___minutes;

	}

//#endregion

}